import { render, staticRenderFns } from "./taskPackageManage.vue?vue&type=template&id=536b4a04&scoped=true&"
import script from "./taskPackageManage.vue?vue&type=script&lang=js&"
export * from "./taskPackageManage.vue?vue&type=script&lang=js&"
import style0 from "./taskPackageManage.vue?vue&type=style&index=0&id=536b4a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b4a04",
  null
  
)

component.options.__file = "taskPackageManage.vue"
export default component.exports